import React, {Component} from 'react';
import { Link } from 'react-router-dom'

class ArticleList extends Component {
  constructor(props) {
    super(props);
    this.state = {articleList: this.props.data};
  }

  renderList() {
    return this.props.data.map(data => (
      <li key={data.id}>
        <Link to={`/dictionary/${data.id}`}>{data.title}</Link>
      </li>
    ));
  }

  render() {
    return (
      <div className="filter-list">
        {this.renderList()}
      </div>
    );
  }
}

export default ArticleList;



// WEBPACK FOOTER //
// ./src/components/Dictionary/ArticleList.js